'use client';

import { useRouter } from 'next/navigation';
import type { ReactNode } from 'react';

export function TypForcedRedirection({
  children,
  pathname,
}: {
  children: ReactNode;
  pathname: string | null;
}) {
  const router = useRouter();

  const savedTyp = window.sessionStorage.getItem('SAVED_TYP');
  if (savedTyp && savedTyp !== pathname) {
    router.push(savedTyp);
  } else {
    return children;
  }
}
